import { render, staticRenderFns } from "./CocinaeasylunchQuicktable.vue?vue&type=template&id=9f1df306&"
import script from "./CocinaeasylunchQuicktable.vue?vue&type=script&lang=js&"
export * from "./CocinaeasylunchQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports